import axios from 'axios';
import useAuthStore from '../store/authStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearUser();
    }
    return Promise.reject(error);
  }
);

// Get all continue listening items for the user
export const getContinueListening = async () => {
  const response = await api.get('/continue-listening');
  return response.data;
};

// Add or update a continue listening item
export const addContinueListening = async ({ item_type, item_id }) => {
  const response = await api.post('/continue-listening', {
    item_type,
    item_id,
  });
  return response.data;
};

// Delete a continue listening item
export const deleteContinueListening = async (id) => {
  const response = await api.delete(`/continue-listening/${id}`);
  return response.data;
};